export default function isAtEndOfBlock(editor) {
  return editor.value.selection.isCollapsed && editor.value.selection.end.isAtEndOfNode(editor.value.endBlock);
}